module.exports = __webpack_public_path__ + "static/media/paint-brush.fae63e22.svg";